import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

const StyledGroup = styled(Group)`
  padding: ${rem(16)} 0;
`

function HotelSearchSplitViewNoResults() {
  return (
    <StyledGroup direction="vertical" horizontalAlign="center" verticalAlign="center" gap={8}>
      <Heading variant="heading3" align="center">
        Sorry, we couldn’t find any offers that match your search criteria.
      </Heading>
      <BodyText variant="medium">
        Try removing some filters or searching a different location to see more options.
      </BodyText>
    </StyledGroup>
  )
}

export default HotelSearchSplitViewNoResults
